import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';
import { Config } from '@/services';

export const emptySplitApi = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: Config.get('apiRoot'),
		prepareHeaders: (headers, { getState }) => {
			const token = (getState() as RootState).auth?.apiToken;

			if (token) {
				headers.set('authorization', `Bearer ${token}`);
			}
			return headers;
		}
	}),

	endpoints: () => ({})
});
